import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        filterButton: {
            color: 'foreground.neutral.default',
            background: 'background.light',
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            display: 'inline-flex',
            alignItems: 'center',
            h: 'auto',
            width: {base: remCalc(115), lg: 'auto'},
            iconSpacing: '0',
            flexDirection: {base: 'row-reverse', lg: 'row'},
        },
        filterText: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            flex: '1 0 0',
        },
        activeFiltersCount: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: remCalc(16),
            height: remCalc(16),
            borderRadius: '50%',
            backgroundColor: 'background.strong.default',
            color: 'foreground.neutral.inverse',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
        },
        filterIcon: {
            color: 'foreground.neutral.default',
            width: remCalc(12),
            height: remCalc(12),
        },
        mobile: {
            display: {
                base: 'inline',
                lg: 'none',
            },
        },
        desktop: {
            display: {
                base: 'none',
                lg: 'inline',
            },
        },
        gridViewIcon: {
            boxSize: 'iconsSize.medium',
            color: 'background.dark',
            fill: 'background.light',
        },
        filtersButtonSpecific: {
            p: {base: ['xsmall.base'], lg: ['xsmall.lg']},
            paddingInline: {base: ['xsmall.lg'], lg: ['small.lg']},
            gap: {base: ['xsmall.lg'], lg: ['small.lg']},
        },
        filterOpenMenu: {
            p: 'small.lg',
            borderRadius: 'none',
            zIndex: 10,
        },
        sortByMenuWrapper: {
            border: '1px solid var(--border-neutral-highlight, #FFF)',
            borderRadius: 'large-1',
            width: '100%',
        },
        sortByFilterMenuList: {
            display: 'flex',
            flexDir: 'column',
            gap: 'xsmall-1.base',
            borderRadius: 'large-1',
            background: 'background.base.elevated',
            paddingY: '0',
            boxShadow:
                'box-shadow: 0 0 0 1px var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 4px 8px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 6px 23px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08))',
        },
        sortByFilterMenuItem: {
            width: '100%',
            marginTop: 0,
            color: 'text.default',
            variant: 'menu-link',
            textStyle: 'body-small',
        },
        gridViewButtonSpecific: {
            display: 'flex',
            flexDirection: 'row',
            paddingTop: remCalc(8),
            paddingBottom: remCalc(8),
            paddingLeft: 'small.base',
            paddingRight: 'small.base',
            gap: 'small.base',
        },
        selectedRefinementsContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            maxWidth: '100%',
            whiteSpace: 'nowrap',
            gap: 'small.base',
            scrollBehavior: 'smooth',
            scrollbarWidth: 'none',
        },
        buttonContainer: {
            marginLeft: remCalc(0),
            marginRight: remCalc(0),
            flexShrink: remCalc(0),
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
        },
        selectedRefinementsButton: {
            color: 'text.default',
            background: 'background.light',
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            border: 'large',
            borderStyle: 'solid',
            borderColor: 'button.background.secondary-hover',
            display: 'inline-flex',
            alignItems: 'center',
            h: 'auto',
            w: 'auto',
            iconSpacing: '0',
            flexDirection: 'row',
            gap: remCalc(8),
            paddingY: remCalc(8),
            paddingX: remCalc(16),
            justifyContent: 'center',
            maxHeight: remCalc(40),
        },
        selectedRefinementsIconBox: {
            boxSize: 'iconsSize.medium',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        preferredRefinementsButton: {
            color: 'text.default',
            background: 'background.light',
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            display: 'inline-flex',
            alignItems: 'center',
            h: '100%',
            w: 'auto',
            paddingY: remCalc(8),
            paddingX: remCalc(16),
            justifyContent: 'center',
            maxHeight: remCalc(40),
            gap: remCalc(8),
        },
        removeAllButtonContainer: {
            w: '100%',
            h: '100%',
            display: 'flex',
            paddingY: remCalc(8),
            gap: remCalc(10),
            alignSelf: 'stretch',
        },
        removeAllButton: {
            maxHeight: remCalc(40),
            padding: remCalc(16),
            paddingInline: ['small.lg'],
            gap: remCalc(10),
        },
        refinementsSelectorButton: {
            p: ['xsmall.lg'],
            gap: ['xxxsmall-1.base'],
        },
    },
    variants: {
        selectedFilterButton: {
            selectedRefinementsContainer: {
                alignItems: 'center',
                h: remCalc(40),
                gap: {
                    base: 'xxxsmall-1.base',
                    sm: 'xxxsmall-1.base',
                    md: 'xxsmall-1.base',
                    lg: 'xxsmall-1.base',
                },
            },
            selectedRefinementsButton: {
                height: '100%',
            },
            removeAllButtonContainer: {
                p: 0,
                h: remCalc(40),
            },
            filterText: {
                whiteSpace: 'nowrap',
            },
        },
        recipesFilters: {
            filterButton: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                h: 'auto',
                iconSpacing: '0',
            },
            selectedRefinementsButton: {
                borderColor: 'primary-default',
            },
            filterText: {
                textStyle: 'body-small',
                fontWeight: 'normal',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                flex: '1 0 0',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
            },
        },
    },
}
